var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "global-tabs global-tabs--vue" },
    [
      _vm.headerType === "filter"
        ? _c("global-filter-list", {
            attrs: {
              "filter-label": _vm.filterLabel,
              options: _vm.tabOptions,
              active: _vm.currentTabIndex,
              "always-show-filter-label": true,
            },
            on: {
              select: function ($event) {
                return _vm.selectTab($event.value)
              },
            },
          })
        : _c(
            "ul",
            { staticClass: "global-tabs__navigation list--exempt" },
            _vm._l(_vm.tabs, function (tab, index) {
              return _c("li", [
                _c(
                  "a",
                  {
                    staticClass: "global-tabs__title",
                    class: [
                      _vm.headerTypeClass,
                      { "tab-active": index === _vm.currentTabIndex },
                    ],
                    on: {
                      click: function ($event) {
                        return _vm.selectTab(index)
                      },
                    },
                  },
                  [_vm._v(_vm._s(tab.header || "Tab " + (index + 1)))]
                ),
              ])
            }),
            0
          ),
      _vm._v(" "),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }